import { Channel } from '../../../../interfaces';
import { getAuth } from '../../../../utils/auth-utils';
import { channelsQuery } from '../../../channels/queries';
import { queryClient } from '../../../client';
import { AtsHttpClient } from '../../ats-http-client';
import { recordingsQuery } from '../../recordings/queries';
import { settings } from '../../settings';
import type { Provider } from './types';
import { createProviders, prepareAtsProviders } from './utils';

const client = new AtsHttpClient();

async function fetchProviders(): Promise<Provider[]> {
  return client.get<Provider[]>('/me/providers', settings.me());
}

async function fetchAnonProviders() {
  return client.get<Provider[]>('/providers', settings.me());
}

export async function getProviders(): Promise<Provider[]> {
  const { isGuest } = getAuth();
  const channels = await queryClient.fetchQuery(channelsQuery());

  if (isGuest) {
    const data = await fetchAnonProviders();
    return createProviders(prepareAtsProviders(data), channels);
  }

  const data = await fetchProviders();
  const outdatedChannels = await getOutdatedPVRChannels(channels);
  return createProviders(prepareAtsProviders(data), [...channels, ...outdatedChannels]);
}

export async function getOutdatedPVRChannels(channels: Channel[]) {
  const recordings = await queryClient.fetchQuery(recordingsQuery());
  const recordingChannelsIds = recordings.map((rec) => {
    return rec.channelId;
  });

  const channelIds = channels.map((channel) => channel.contentId);
  const outdatedChannelIds = recordingChannelsIds
    .map((id) => {
      if (channelIds.indexOf(id) === -1) {
        return id;
      }
      return false;
    })
    .filter((x) => x);

  const outdatedChannels = outdatedChannelIds.map((id) => {
    const recordingToOutdatedChannel = recordings.find((rec) => rec.channelId === id);

    if (recordingToOutdatedChannel) {
      return {
        contentId: id,
        name: recordingToOutdatedChannel.channelName,
        channelPermissions: { notInSubscription: true },
      } as Channel;
    }
    return { contentId: id, channelPermissions: { notInSubscription: true } } as Channel;
  });

  return outdatedChannels;
}
